const r = "Presiona Tab para ir a Popover", t = {
  triggerHint: r
};
export {
  t as default,
  r as triggerHint
};
